import React, { useState, useRef } from 'react';
import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";

export function AEPSReceiptModa({
  receiptData = null,
  isOpen = false,
  onClose = () => {},
  title = "Transaction Receipt",
  logoUrl = "/assets/images/logo/skpe.png",
}) {

  const receiptRef = useRef();

  const safe = (v, def = "N/A") =>
    v === null || v === undefined || v === "" ? def : v;

  const formatCurrency = (amount) => {
    if (!amount || amount === "null") return "₹0.00";
    return `₹${parseFloat(amount).toFixed(2)}`;
  };


  const getStatusClass = (status) => {
    if (status === true || status === "success") return "text-success";
    if (status === false || status === "failed") return "text-danger";
    return "text-warning";
  };

  const mapTransectionType = (type) => {
    switch ((type || "").toUpperCase()) {
      case "BE": return "Balance Enquiry";
      case "CW": return "Cash Withdrawal";
      case "CD": return "Cash Deposit";
      case "MS": return "Mini Statement";
      default: return safe(type);
    }
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          title: "Transaction Receipt",
          text: "Here is your transaction receipt",
          url: window.location.href,
        })
        .catch(() => {});
    } else alert("Sharing not supported");
  };

  const handlePrint = () => {
    if (!receiptRef.current) return;
    const printContents = receiptRef.current.innerHTML;
    const newWindow = window.open("", "_blank");
    newWindow.document.write(`
      <html>
        <head>
          <title>Receipt</title>
          <link rel="stylesheet"
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
        </head>
        <body>${printContents}</body>
      </html>
    `);
    newWindow.document.close();
    newWindow.print();
  };

  const handleDownload = () => {
    if (!receiptRef.current) return;
    const opt = {
      margin: 0.5,
      filename: "receipt.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };
    html2pdf().set(opt).from(receiptRef.current).save();
  };

  if (!isOpen) return null;

  const data = receiptData || {};

  // ✅ AEPS FIELD MAPPING FROM NEW API
  const tableData = [
    { label: "Transaction Type", value: mapTransectionType(data.transection_type) },
    { label: "Order ID", value: safe(data.order) },
    { label: "Customer", value: safe(data.customer) },
    { label: "Aadhar", value: safe(data.aadhar_number) },
    { label: "Bank IIN", value: safe(data.bank_name) },
    { label: "Amount", value: formatCurrency(data.amount) },
    { label: "Message", value: safe(data.desc) },
    { label: "Date & Time", value: safe(data.created_at) },
    {
      label: "Status",
      value: (data.status || "").toUpperCase(),
      isStatus: true,
    },
  ];

  return (
    <div
      className="modal fade show"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
      onClick={onClose}
    >
      <div
        ref={receiptRef}
        className="modal-dialog modal-fullscreen-md-down"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">

          <div className="modal-header">
            <h4 className="main-title">{title}</h4>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body p-0">
            <div className="container invoice-container">
              <div className="row">
                <div className="col-12">

                  <div className="card">
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table">

                          {/* HEADER */}
                          <tr>
                            <td>
                              <table className="table table-lg w-100 invoice-header">
                                <tbody>
                                  <tr>
                                    <td>
                                      <img src={logoUrl} alt="LOGO"
                                        style={{ width: "200px", height: "60px", objectFit: "contain" }} />
                                      <address>Customer Copy - AEPS Receipt</address>
                                    </td>

                                    <td>
                                      <div className="text-end">
                                        <h3 className="text-primary">RECEIPT</h3>
                                        <p><strong>{safe(data.datetime)}</strong></p>
                                        <p>
                                          <strong className={getStatusClass(data.status)}>
                                            {(data.status  == "success" || data.status == true || data.status == "Success") ? "SUCCESS" : "FAILED"}
                                          </strong>
                                        </p>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>

                          {/* MAIN TABLE */}
                          <tr>
                            <td>
                              <table className="table table-lg table-bottom-border w-100">
                                <thead>
                                  <tr>
                                    <th>Description</th>
                                    <th>Details</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {tableData.map((row, i) => (
                                    <tr key={i}>
                                      <td style={{ fontWeight: "500" }}>{row.label}</td>
                                      <td>
                                        {row.isStatus ? (
                                          <span className={getStatusClass(row.value)}>
                                            <strong>{row.value}</strong>
                                          </span>
                                        ) : (
                                          row.value
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </td>
                          </tr>

                          {/* ✅ MINI STATEMENT (FROM ORIGINAL API) */}
                          {data.ministatement?.length > 0 && (
                            <tr>
                              <td>
                                <h5 className="text-center mb-3 fw-bold text-primary">
                                  Mini Statement
                                </h5>

                                <table className="table table-bordered text-center">
                                  <thead className="table-light">
                                    <tr>
                                      <th>Date</th>
                                      <th>Txn Type</th>
                                      <th>Amount</th>
                                      <th>Narration</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {data.ministatement.map((txn, idx) => (
                                      <tr key={idx}>
                                        <td>{txn.date}</td>
                                        <td>{txn.txnType}</td>
                                        <td>{formatCurrency(txn.amount)}</td>
                                        <td>{txn.narration}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          )}

                          {/* FOOTER NOTE */}
                          <tr>
                            <td>
                              <div className="text-center p-3 bg-light rounded">
                                <strong>Note:</strong> This is a system generated receipt.
                              </div>
                            </td>
                          </tr>

                        </table>
                      </div>

                    </div>
                  </div>

                  {/* FOOTER BUTTONS */}
                  <div className="invoice-footer float-end mb-3">
                    <button className="btn btn-primary m-1" onClick={handlePrint}>
                      Print
                    </button>
                    <button className="btn btn-secondary m-1" onClick={handleShare}>
                      Share
                    </button>
                    <button className="btn btn-success m-1" onClick={handleDownload}>
                      Download
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
